import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  gap: 20px;
`;

export const Title = styled.h4`
  text-align: center;
  font-size: 16px;
  font-weight: normal;
  self-align: start;
  color: ${({ theme }) => theme.colors.textBackground};
`;
